// elements without inner content.
// Todo: add element if missing on using clipboard
export const VOID_ELEMENTS = [
  'area',
  'base',
  'br',
  'col',
  'command',
  'embed',
  'hr',
  'img',
  'input',
  'keygen',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr',
];

export const NEWLINE_CHAR_CODE = 10; // '\n'
export const DOUBLE_QUOTE_CHAR_CODE = 34; // '"'
export const AMPERSAND_CHAR_CODE = 38; // '&'
export const SINGLE_QUOTE_CHAR_CODE = 39; // '\''
export const FORWARD_SLASH_CHAR_CODE = 47; // '/'
export const SEMICOLON_CHAR_CODE = 59; // ';'
export const TAG_OPEN_CHAR_CODE = 60; // '<'
export const EQUAL_SIGN_CHAR_CODE = 61; // '='
export const TAG_CLOSE_CHAR_CODE = 62; // '>'

export const CHAR_OF_INTEREST_REGEX = /[<&\n\ud800-\udbff]/;

export const SIMPLIFY_WHITESPACE_REGEX = /\s{2,}/g;

// trim trailing spaces before newlines in single multi-line string
export const TRIM_TRAILING_SPACES = /[^\S\r\n]+$/gm;

// TODO: add \r if match is not correct
export const MATCH_LINE_BREAKS = /\r\n?|\n/g;

export const MATCH_ALL_LINE_BREAKS = /(\n\n|\r\n|\n|\r)/gm;

// searches for any spaces from the beginning of the string and from the end of string
export const SPACES_BEFORE_AND_END = /[^\S\r\n]+$/gm;

// check for contiguous string of space char
export const CONTIGUOUS_STRING_SPACE_CHAR = /\s+/g;
